'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' });

var Layers = function Layers(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Layers = (0, _pure2.default)(Layers);
Layers.muiName = 'SvgIcon';

exports.default = Layers;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Layers.js
// module id = 2537
// module chunks = 0